import { Chip, Group, Stack, Text } from '@mantine/core';
import type { FC } from 'react';

import { ALL_DAYS, WEEKDAYS } from './scheduleTiming';

type Props = {
    frequency: 'DAILY' | 'WEEKLY';
    /** The days it sends on. */
    days: number[];
    onChange: (days: number[]) => void;
};

/** Weekly picks the days to send on; daily picks the days to skip. Both store the days it sends. */
const ScheduleDaysPicker: FC<Props> = ({ frequency, days, onChange }) => {
    const skipping = frequency === 'DAILY';
    const picked = WEEKDAYS.filter((d) => days.includes(d.value) !== skipping).map((d) => String(d.value));

    const handleChange = (next: string[]) => {
        const chosen = next.map(Number);
        onChange(skipping ? ALL_DAYS.filter((d) => !chosen.includes(d)) : chosen);
    };

    return (
        <Stack gap={4}>
            <Text size="sm" fw={500}>
                {skipping ? 'Skip these days' : 'Send on'}
            </Text>
            <Chip.Group multiple value={picked} onChange={handleChange}>
                <Group gap={4}>
                    {WEEKDAYS.map((d) => (
                        <Chip key={d.value} value={String(d.value)} size="xs" color="indigo">
                            {d.label}
                        </Chip>
                    ))}
                </Group>
            </Chip.Group>
            {days.length === 0 && (
                <Text size="xs" c="red">
                    Pick at least one day to send on.
                </Text>
            )}
        </Stack>
    );
};

export default ScheduleDaysPicker;
